import { render, staticRenderFns } from "./ServiceModel.vue?vue&type=template&id=74421efe&scoped=true"
import script from "./ServiceModel.vue?vue&type=script&lang=js"
export * from "./ServiceModel.vue?vue&type=script&lang=js"
import style0 from "./ServiceModel.vue?vue&type=style&index=0&id=74421efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74421efe",
  null
  
)

export default component.exports